import { registerCustomDetailComponent, registerPageTab } from '@vendure/admin-ui/core';
import { ProductVariantEnabilityFormComponent } from './product-variant-enability-form/product-variant-enability-form.component';
import { ProductVariantListComponent } from './product-variant-list/product-variant-list.component';

export default [
    registerCustomDetailComponent({
        locationId: 'product-variant-detail',
        component: ProductVariantEnabilityFormComponent,
    }),
    registerPageTab({
        location: 'product-list',
        tab: 'Food Variants',
        route: 'food-variants',
        component: ProductVariantListComponent,
    }),
];
